import script from "./room.vue?vue&type=script&lang=ts&setup=true"
export * from "./room.vue?vue&type=script&lang=ts&setup=true"

import "./room.vue?vue&type=style&index=0&id=76e3f2f7&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/ALLIANCE_FRONTEND1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76e3f2f7"]])

export default __exports__